import Backbone from 'backbone'
import _ from 'lodash'
import template from './button-widget-editor.hbs'
import formHelper from 'scoreboard/components/form-helper'
import getEditorTitle from './get-editor-title'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import enums from 'scoreboard/components/enums'
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { BUTTON } = FormWidgetType
import FormActions from '../edit/form-actions'
import i18n from 'scoreboard/components/i18n'
import widgetMetadata from './widget-metadata'

const ButtonWidgetEditor = Backbone.View.extend({

	className: 'form-widget-editor button-widget-editor',

	tagName: 'form',

	events: {
		'input [name=buttonLabel]': 'onChangeButtonLabel',
		'click .button-primary': 'showRemainingCollapsedFields'
	},

	/** @type {Form} */
	model: null,

	/**
	 * Dialog for editing a button form widget
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model
	 *
	 * @param {FormWidget} options.widget the data for the widget
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		formHelper.writeToDom(this.options.widget, this.el)
		this.renderActions()
		this.renderButtonLabelField()
		this.formView.start()
		this.renderStateToggle()
		this.renderAppearanceToggle()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		return this
	},

	renderActions: function() {
		this.actions = new FormActions({
			model: this.model,
			statements: this.options.widget.statements,
			title: i18n.get('forms.actions.title'),
			formView: this.formView,
			emptyMessage: i18n.get('forms.actions.emptyButtonClick')
		})
		this.$('.actions-container').append(this.actions.el)
		this.actions.render()
	},

	onChangeButtonLabel: function() {
		this.formActions && this.formActions.rerenderWidgetSelects()
	},

	renderStateToggle: function() {
		// circular dependency
		let states = widgetMetadata.states[BUTTON]
		this.stateToggle = new LabeledToggle({
			name: 'state',
			value: _.get(this.options.widget, 'state'),
			options: _.filter(enums.toOptionData('widgetState'), item => {
				if (_.includes(states, item.id)) {
					return _.extend(item, { value: item.id })
				}
			})
		})

		this.$('.widget-state .labeled-toggle-container').append(this.stateToggle.el)
		this.stateToggle.render()
		this.stateToggle.on('change', () => {
			this.formView.change()
		})
	},

	renderButtonLabelField: function() {
		this.buttonLabelField = new MarkedField({
			el: this.$('[name=buttonLabel]'),
			validator: requiredValidator
		}).render()
	},

	renderAppearanceToggle: function() {
		this.appearanceToggle = new LabeledToggle({
			name: 'appearance',
			value: this.options.widget?.appearance,
			options: [
				{ label: i18n.get('forms.appearance.primary'), value: 'primary' },
				{ label: i18n.get('forms.appearance.secondary'), value: 'secondary' }
			]
		})

		this.$('.appearance-toggle-container').append(this.appearanceToggle.el)
		this.appearanceToggle.render()
		this.listenTo(this.appearanceToggle, 'change', () => {
			this.formView.change()
		})
	},

	context: function() {
		return {
			title: getEditorTitle(this.options.widget),
			bannerMsg: i18n.get('forms.actions.buttonClickActionsBanner',
				i18n.get('forms.actions.actionsBannerPart2'))
		}
	},

	submit: function() {
		let data = formHelper.readFromDom(this.el)
		data = _.pick(data, 'label', 'description', 'buttonLabel', 'state', 'appearance')
		data.statements = this.actions.getData()
		this.trigger('done', data)
	},

	autoRemove: true

})

export default ButtonWidgetEditor

ButtonWidgetEditor.__filename__ = 'forms/widgets/button-widget-editor.js'
